import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ZoonosesComponent } from './zoonoses/zoonoses.component';
import { ZoonosesService } from './zoonoses.service';
import { LoginComponent } from './login/login.component';
import { SuspicionDatePipe } from './suspicion-date.pipe';
import { CommentsPipePipe } from './comments-pipe.pipe';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    ZoonosesComponent,
    LoginComponent,
    SuspicionDatePipe,
    CommentsPipePipe
  ],
  providers: [ ZoonosesService ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/app.module.ts